import { render } from "./RecruitmentSubmissionStatusButton.vue?vue&type=template&id=0797a825&scoped=true"
import script from "./RecruitmentSubmissionStatusButton.vue?vue&type=script&lang=js"
export * from "./RecruitmentSubmissionStatusButton.vue?vue&type=script&lang=js"

import "./RecruitmentSubmissionStatusButton.vue?vue&type=style&index=0&id=0797a825&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0797a825"]])

export default __exports__